import { Box, VisuallyHidden } from '@chakra-ui/react'
import React from 'react'

import { CircleBadgeVariant } from './componentStyles/CircleBadge.style'
import { usePulsingCircleBadgeStyle } from './componentStyles/PulsingCircleBadge.style'

interface PulsingCircleBadgeProps {
  variant: CircleBadgeVariant
  /** Screen-reader text for the status the color conveys. */
  label?: string
}
export const PulsingCircleBadge = ({
  variant,
  label,
}: PulsingCircleBadgeProps) => {
  const style = usePulsingCircleBadgeStyle({ variant })
  return (
    <>
      <Box css={style} />
      {label && <VisuallyHidden>{label}</VisuallyHidden>}
    </>
  )
}
